export const fetchComments = resp => {
  return {
    type: "FETCH_COMMENTS",
    payload: resp
  };
};
export const saveComment = resp => ({
  type: "SAVE_COMMENT",
  payload: resp
});

export const saveVoiceComment = resp => ({
  type: "SAVE_VOICE_COMMENT",
  payload: resp
});

export const AddComment = comments => {
  return {
    type: "ADD_COMMENT",
    comments
  };
};
export const setCommentSlideCode = slideCode => {
  return {
    type: "SET_COMMENT_SLIDE_CODE",
    slideCode
  };
};
export const setTarget = target => {
  return {
    type: "SET_TARGET",
    target
  };
};
export const addCommentComponentId = componentId => ({
  type: "SET_COMPONENT_ID",
  componentId
});
export const addCommentContent = content => ({
  type: "ADD_COMMENT_CONTENT",
  content
});
export const setIsVisible = isVisible => ({
  type: "SET_IS_VISIBLE",
  isVisible
});
export const setSelectedComponent = selectedComponent => ({
  type: "SET_SELECTED_COMPONENT",
  selectedComponent
});
export const setComponentComment = comments => ({
  type: "SET_COMPONENT_COMMENTS",
  comments
});
export const setPresentationState = presentationState => ({
  type: "SET_PRESENTATION_STATE",
  presentationState
});
export const deleteComment = resp => {
  return {
    type: "DELETE_COMMENT",
    payload: resp
  };
};
export const setDiaporamaSpeed = speed => {
  return {
    type: "SET_DIAPORAMA_SPEED",
    speed
  };
};
export const setFirstTime = firstTime => {
  return {
    type: "SET_FIRST_TIME",
    firstTime
  };
};
export const setProgressBar = progress => {
  return {
    type: "SET_PROGRESS_BAR",
    progress
  };
};
export const setCommentUpdate = commentUpdate => {
  return {
    type: "SET_COMMENT_UPDATE",
    commentUpdate
  };
};

export const setExtraSlidesInModal = val => {
  return {
    type: "SET_EXTRA_SLIDES_IN_MODAL_BOOL",
    val
  };
};

export const setExtraSlideUsable = extraSlideUsable => {
  return {
    type: "SET_EXTRA_SLIDE_USABLE",
    extraSlideUsable
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/PreparePresentation.js